import * as yup from 'yup';

export const FORM_ID = 'campaign--settings-form';

export const SAVE_BUTTON_TEXT = 'Save Campaign';

export interface FormValues {
  name: string;
  isActive: boolean;
}

export const validation = yup.object().shape({
  name: yup.string().required('Campaign name is a required field'),
});
